import { Column } from "primereact/column";
import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { fetchData } from "../../../../Services/GlobalService";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import * as Fa from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";

const SchemeDiscDefAllRec = () => {
  const Controller = "SchemeFlatDiscount";
  const Controllermulti = "SchemeMultiDiscount";
  const SchmEndPoint = {
    GetAllFlatDiscountData: "GetAllFlatDiscountData",
    GetLineLevelAllSchemeData: "GetLineLevelAllSchemeData",
  };
  const UserId = localStorage.getItem("UserId")?.toString();
  const [allSchmDataFlat, setAllSchmDataFlat] = useState<any>([]);
  const [allSchmDataLinelvl, setAllSchmDataLinelvl] = useState<any>([]);
  const [statuses] = useState(["Active", "Inactive"]);
  const [schmstatuses] = useState(["Customer", "Segment"]);
  const [schmstatusesLinelvl] = useState(["Pecentage", "Value"]);
  const [tabIndex, setTabIndex] = useState(0);

  const nav = useNavigate();
  // showFilterMenu={false} filter filterElement={statusRowFilterTemplate}
  useEffect(() => {
    const fetchAllSchmdt = async () => {
      try {
        const schmres = await fetchData(
          Controller,
          `${SchmEndPoint.GetAllFlatDiscountData}`,
          `UserId=${UserId}`,
        );
        setAllSchmDataFlat(schmres.Data);
      } catch (error) {
      } finally {
      }
    };
    const fetchAllSchmlinedt = async () => {
      try {
        const schmres = await fetchData(
          Controllermulti,
          `${SchmEndPoint.GetLineLevelAllSchemeData}`,
          `SCHEME_CODE=`,
        );
        setAllSchmDataLinelvl(schmres.Data);
      } catch (error) {
      } finally {
      }
    };
    fetchAllSchmdt();
    fetchAllSchmlinedt();
  }, []);

  console.log("allSchmDataLinelvl",allSchmDataLinelvl);

  const statusRowFilterTemplate = (options: any) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "8rem" }}
      />
    );
  };
  const statusschmRowFilterTemplate = (options: any) => {
    return (
      <Dropdown
        value={options.value}
        options={schmstatuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "8rem" }}
      />
    );
  };

  const statusItemTemplate = (option: any) => {
    return <Tag value={option} className="custom-tag" />;
  };

  const statusFilterLinelvl = (options: any) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "8rem" }}
      />
    );
  };
  const statusFilterTemplatelinlvl = (options: any) => {
    return (
      <Dropdown
        value={options.value}
        options={schmstatusesLinelvl}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplateLine}
        placeholder="Select One"
        className="p-column-filter"
        showClear
        style={{ minWidth: "8rem" }}
      />
    );
  };

  const statusItemTemplateLine = (option: any) => {
    return <Tag value={option} className="custom-tag" />;
  };

  const renderActionFlat = (rowdata: any) => {
    return (
      <>
        <div className="action-icon">
          <div
            className="d-inline"
            data-toggle="tooltip"
            data-placement="bottom"
            title="View"
          >
            <button
              className="grid-icon"
              onClick={() => {
                nav(
                  `/Master/Scheme/SchemeDiscountDefinition?schmID=${encodeURIComponent(
                    rowdata.SCHM_CODE,
                  )}&Schmtype=FlatDisc`,
                );
              }}
            >
              <Fa.FaEye />
            </button>
          </div>
        </div>
      </>
    );
  };
  const renderActionLine = (rowdata: any) => {
    return (
      <>
        <div className="action-icon">
          <div
            className="d-inline"
            data-toggle="tooltip"
            data-placement="bottom"
            title="View"
          >
            <button
              className="grid-icon"
              onClick={() => {
                nav(
                  `/Master/Scheme/SchemeDiscountDefinition?schmID=${encodeURIComponent(
                    rowdata.SCHEME_CODE,
                  )}&Schmtype=LineLvl&discType=${rowdata.SCHEME_STATUS}`,
                );
              }}
            >
              <Fa.FaEye />
            </button>
          </div>
        </div>
      </>
    );
  };

  const gotoAddnew = () => {
    nav(`/Master/Scheme/SchemeDiscountDefinition?schmID=null`);
  };

  const activeTabIndex = (e: any) => {
    setTabIndex(e.index);
  };

  return (
    <>
      <main>
        <div className="col-12 mb-5">
          <div className="row">
            {/* Breadcrumb  */}
            <div className="col-lg-12 col-md-12 col-sm-12">
              <nav aria-label="breadcrumb" className="drop-in">
                <ol className="breadcrumb mx-0">
                  <li className="breadcrumb-item">Masters</li>
                  <li className="breadcrumb-item" aria-current="page">
                    Scheme
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Scheme Discount Definition
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h3 className="py-2">Scheme Discount Definition</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="text-end mb-2">
                <button
                  type="button"
                  className="btn anime-btn"
                  onClick={gotoAddnew}
                >
                  Add New Scheme
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="Tab-Pannel">
            <TabView
              activeIndex={tabIndex}
              onTabChange={(e) => activeTabIndex(e)}
            >
              <TabPanel header="Flat Discount">
                <div className="DataTable">
                  <DataTable
                    value={allSchmDataFlat}
                    paginator
                    rows={10}
                    filterDisplay="row"
                    scrollable
                    rowsPerPageOptions={[10, 25, 50]}
                    scrollHeight="80vh"
                    showGridlines
                    stripedRows
                    // tableStyle={{ minWidth: "100rem" }}
                  >
                    <Column
                      field="SCHM_CODE"
                      header="Scheme Code"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="SCHM_NAME"
                      header="Scheme Name"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="DISCOUNT_VAL"
                      header="Discount(%)"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="SCHEME_LEVEL"
                      header="Scheme Level"
                      showFilterMenu={false}
                      filter
                      filterElement={statusschmRowFilterTemplate}
                      body={(rowdata) =>
                        rowdata.SCHEME_LEVEL == "CUSTOMER"
                          ? "Customer"
                          : "Segment"
                      }
                    />
                    <Column
                      field="START_DATE"
                      header="Start Date"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="END_DATE"
                      header="End Date"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="IS_ACTIVE"
                      header="Status"
                      showFilterMenu={false}
                      filter
                      filterElement={statusRowFilterTemplate}
                      style={{ width: "6rem" }}
                    />
                    <Column
                      body={renderActionFlat}
                      field=""
                      header="Action"
                    ></Column>
                  </DataTable>
                </div>
              </TabPanel>
              <TabPanel header="Line Level Discount">
                <div className="DataTable">
                  <DataTable
                    value={allSchmDataLinelvl}
                    paginator
                    rows={10}
                    filterDisplay="row"
                    scrollable
                    rowsPerPageOptions={[10, 25, 50]}
                    scrollHeight="80vh"
                    showGridlines
                    stripedRows
                    // tableStyle={{ minWidth: "80rem" }}
                  >
                    <Column
                      field="SCHEME_CODE"
                      header="Scheme Code"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="SCHEME_NAME"
                      header="Scheme Name"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="DISCOUNT_TYPE"
                      header="Discount Base"
                      showFilterMenu={false}
                      // filter
                      // filterElement={statusFilterTemplatelinlvl}
                      body={(rowdata) =>
                        rowdata.DISCOUNT_TYPE == "PERCENT"
                          ? "Pecentage"
                          : "Value"
                      }
                    />
                    <Column
                      field="START_DATE"
                      header="Start Date"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="END_DATE"
                      header="End Date"
                      filter
                      filterMatchMode="contains"
                      filterPlaceholder="Search Here..."
                    ></Column>
                    <Column
                      field="ACTIVATION_STATUS"
                      header="Status"
                      showFilterMenu={false}
                      filter
                      filterElement={statusFilterLinelvl}
                      style={{ width: "6rem" }}
                    />
                    <Column
                      body={renderActionLine}
                      field=""
                      header="Action"
                    ></Column>
                  </DataTable>
                </div>
              </TabPanel>
            </TabView>
</div>          </div>
        </div>
      </main>
    </>
  );
};

export default SchemeDiscDefAllRec;
